import requests from 'service/api'
import AsyncSearchSelect from '../async-search-select'
import { asOptions, firstOption } from 'lib/asyncList'

export function SelectFabricType({ name, brrand }) {
  const isHome = brrand === 'ZaraHome'
  const mapType = ({ name: label }) => ({ value: label, label })
  const list = (params) => (isHome ? requests.fabric.typeListHome(params) : requests.fabric.typeList(params))

  return (
    <AsyncSearchSelect
      name={name}
      fetchSelected={(selected) => firstOption(list({ selected }), mapType)}
      fetchOptions={(search) => asOptions(list({ search, limit: 20 }), mapType)}
    />
  )
}
